import { render, staticRenderFns } from "./KitCard.vue?vue&type=template&id=231ebfd6&scoped=true&"
import script from "./KitCard.vue?vue&type=script&lang=ts&"
export * from "./KitCard.vue?vue&type=script&lang=ts&"
import style0 from "./KitCard.vue?vue&type=style&index=0&id=231ebfd6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231ebfd6",
  null
  
)

export default component.exports